<template>
  <v-dialog :value="show" max-width="600px" persistent scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">Для дистрибьюторов</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="distributorId"
                :items="distributors"
                :loading="loading"
                item-text="name"
                item-value="id"
                label="Дистрибьютор"
                clearable
                persistent-hint
                hint="Свой дистрибьютор логина — по нему считается отчёт «Рейтинг»"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="Close">Отмена</v-btn>
        <v-btn text :loading="saving" @click="Save">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
    userId: { type: String, default: null },
  },
  data: () => ({
    distributors: [],
    distributorId: null,
    loading: false,
    saving: false,
  }),
  watch: {
    show(val) {
      if (!val) return;

      this.distributorId = null;
      this.LoadData();
    },
  },
  methods: {
    async LoadData() {
      this.loading = true;

      try {
        const [distributors, relation] = await Promise.all([
          this.$store.dispatch("GET_DISTRIBUTORS_FOR_RELATION"),
          this.$store.dispatch("GET_DISTRIBUTOR_RELATION", this.userId),
        ]);

        this.distributors = distributors;
        this.distributorId = relation.distributorId;
      } catch (error) {
        this.ShowError(error);
        this.Close();
      } finally {
        this.loading = false;
      }
    },
    async Save() {
      this.saving = true;

      try {
        await this.$store.dispatch("SAVE_DISTRIBUTOR_RELATION", {
          userId: this.userId,
          distributorId: this.distributorId,
        });

        this.$store.commit("SET_SNACKBAR", {
          text: this.distributorId
            ? "Дистрибьютор пользователя сохранён!"
            : "Привязка к дистрибьютору снята!",
          timeout: 5000,
          color: "success",
          show: true,
        });

        this.$emit("saved");
      } catch (error) {
        this.ShowError(error);
      } finally {
        this.saving = false;
      }
    },
    Close() {
      this.$emit("close");
    },
    // Текст ошибки пользователю уже показывает перехватчик axios
    ShowError(error) {
      window.console.log(error);
    },
  },
};
</script>
